import createAxios from "./axiosHttp";

function getWarehouses(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/warehouse/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

function exportar(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/warehouse/ql/export";
  return axios.post(
    urlPath,
    { pagination, query, sort },
    { responseType: "arraybuffer" }
  );
}

function getWarehouseById(warehouse_id) {
  const axios = createAxios();
  const urlPath = `ttmm/warehouse/${warehouse_id}`;
  return axios.get(urlPath);
}

function createWarehouse(body) {
  const axios = createAxios();
  const urlPath = "ttmm/warehouse";
  return axios.post(urlPath, body);
}

function updateWarehouse(body, warehouse_id) {
  const axios = createAxios();
  const urlPath = `ttmm/warehouse/${warehouse_id}`;
  return axios.put(urlPath, body);
}

function deleteWarehouse(warehouse_ids) {
  const axios = createAxios();
  const urlPath = `ttmm/warehouse/${warehouse_ids}`;
  return axios.delete(urlPath);
}

export const warehouseService = {
  getWarehouses,
  exportar,
  getWarehouseById,
  createWarehouse,
  updateWarehouse,
  deleteWarehouse,
};
